import gsap from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';


export default class FullDive{


    constructor(){
        this._init();
    }


    _init(){
        gsap.registerPlugin(ScrollTrigger);
        this.throttle = 0;
        this._update();
        this._fixed();
    }


    _update(){
        if(!document.querySelector('.event__fulldive__item')) return;

        if(this.throttle%3 == 0) gsap.set('.event__fulldive__item', {backgroundPositionX:'-=1'});
        this.throttle++;
        requestAnimationFrame(this._update.bind(this));
    }

    _fixed(){
        ScrollTrigger.create({
            trigger: ".event__main",
            start: "top 0",
            //end: "bottom 100%",
            toggleClass: { targets: ".event__fulldive", className: "-fixed" },
        });
    }
}
